import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import { Button, Modal, Col, Row } from "react-bootstrap";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiRegion from "../../../core/api/api.region";
import StrictModeDroppable from "../_Components/StrictModeDroppable";

const ChangeOrderAmusementService = ({ showModalAmusementsOrder, setShowModalAmusementsOrder, selectedGroupId }) => {
  const [items, setItems] = useState([]);
  const [listAmusementGroup, setListAmusementGroup] = useState([]);
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedAmusementGroup, setSelectedAmusementGroup] = useState(null);

  const getAmusemntServices = async (selectedAmusementGroup, selectedCity) => {
    try {
      const response = await ApiAmusementService.getAllServicesByGroupId({
        groupId: selectedAmusementGroup?.value,
        regionId: selectedCity?.value,
      });
      setItems(response);
    } catch (error) {
    }
  };

  const handleGroupChange = (selectedOption) => {
    setSelectedAmusementGroup(selectedOption);
    getAmusemntServices(selectedOption, selectedCity);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    getAmusemntServices(selectedAmusementGroup, selectedOption);
  };


  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedItems = Array.from(items);
    const [reorderedItem] = updatedItems.splice(result.source.index, 1);
    updatedItems.splice(result.destination.index, 0, reorderedItem);

    setItems(updatedItems);
  };

  const handleClose = () => {
    setShowModalAmusementsOrder(false);
  };

  const sendSortedItems = async () => {
    if (!selectedCity) {
      SwalMessage({ title: "لطفا شهر را انتخاب کنید", iSsuccess: false });
      return;
    }
    try {
      const dataToSend = {
        services: items.map((item) => ({ id: item.amusementServiceId, name: item.amusementService.name })),
        groupId: selectedAmusementGroup?.value,
        regionId: selectedCity?.value,
      };

      const response = await ApiAmusementService.changeOrderAmusementService(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
      //setShowModalAmusementsOrder(false);
    } catch (error) {
    }
  };

  useEffect(() => {
    (async () => {
      try {
        if (selectedGroupId) {
          const [servicesResponse, groupsResponse, citiesResponse] = await Promise.all([
            ApiAmusementService.getAllServicesByGroupId({ groupId: selectedGroupId }),
            ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 }),
            ApiRegion.getAllCity(),
          ]);

          setItems(servicesResponse);
          setListAmusementGroup(groupsResponse.data);
          setAllAmusementCityList(citiesResponse);

          const initialGroup = groupsResponse.data.find((service) => service.id === selectedGroupId);
          if (initialGroup) {
            setSelectedAmusementGroup({
              value: initialGroup.id,
              label: initialGroup.title,
            });
          }
        }
      } catch (error) {
      }
    })();
  }, [selectedGroupId]);

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered size="md" show={showModalAmusementsOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری سرویس‌ها در این دسته</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="gx-1 mb-2">
              <Col sm="4" className="pr-sm-0">
                <SelectComponent
                  className=" mt-2"
                  placeholder="شهر"
                  options={allAmusementCityList.map((item) => ({
                    value: item.id,
                    label: `${item.id}-${item.name}`,
                  }))}
                  onChange={handleCityChange}
                  value={selectedCity}
                />
              </Col>
              <Col sm="8" className="">
                <SelectComponent
                  className=" mt-2"
                  placeholder="دسته تفریح"
                  options={listAmusementGroup.map((item) => ({
                    value: item.id,
                    label: item.title,
                  }))}
                  onChange={handleGroupChange}
                  value={selectedAmusementGroup}
                  isDisabled
                />
              </Col>
            </Row>

            <DragDropContext onDragEnd={handleDragEnd}>
              <StrictModeDroppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {items.map((item, index) => (
                      <Draggable
                        key={item.amusementServiceId.toString()}
                        draggableId={item.amusementServiceId.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.amusementService.name}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </StrictModeDroppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={!selectedCity} onClick={sendSortedItems}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default ChangeOrderAmusementService;
